import React, {
  FC,
  PropsWithChildren,
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'

export interface ToastProviderContextType {
  setToastMessage: (message: string) => void
  visible: boolean
  message?: string
}

export const ToastContext = createContext<ToastProviderContextType>(null as any)

const ToastProvider: FC<PropsWithChildren> = ({ children }) => {
  const [message, setMessage] = useState<string>()
  const [toastCount, setToastCount] = useState(0)
  const [visible, setVisible] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout>()

  const setToastMessage = useCallback(
    (message: string) => {
      setMessage(message)
      setToastCount((old) => old + 1)
    },
    [setMessage, setToastCount]
  )

  useEffect(() => {
    setVisible(!!message)

    timeoutRef.current = setTimeout(() => {
      setVisible(false)
    }, 2000)

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [message, toastCount])

  const value = useMemo(() => {
    return { setToastMessage, message, visible }
  }, [setToastMessage, message, visible])

  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
}

export default ToastProvider
